import { formatDate } from 'devextreme/localization';
import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { useGetCompany } from '../../../../api/company';
import { Card, Field } from '../../../../layouts';
import { RetailOrderContext } from '../context/RetailOrderContext';

export default function StoreInformationCard() {

	const { order } = useContext(RetailOrderContext);

	const store = useGetCompany(order.details.dealerCompanyID);

	return (
		<>
			<Card
				header={'Store Information'}
				className={'store-info-card field-label-40'}
			>
				<Field label={'Parent Company'} >{store.data?.parentCompanyName}</Field>
				<Field label={'Number'} >{store.data?.companyCode + ' - ' + store.data?.companyName}</Field>
				<Field label={'Address'} >{store.data?.PA_Address1}</Field>
				<Field label={''} visible={!!store.data?.PA_Address2}>{store.data?.PA_Address2}</Field>
				<Field label={''} >{store.data?.PA_City + ', ' + store.data?.PA_State + ' ' + store.data?.PA_Zip}</Field>
				<Field label={'Phone'} >{store.data?.phone}</Field>
				<Field label={'Sales Associate'} visible={!!order.details.salesAssocName}>{order.details.salesAssocName}</Field>
				<Field label={'Payment Schedule'} >
					{
						!!order.details.feeBucketCode &&
						<Link to={`/cfi/payment-schedule/details?priceBucketID=${order.details.priceBucketID}&priceBucketVersioningID=${order.details.priceBucketVersioningID}&date=${formatDate(order.details.roDate, 'yyyy-MM-dd')}`}
							target="_blank">
							{`${order.details.feeBucketCode} (${order.details.isPromo ? 'PROMO' : 'STANDARD'})`}
						</Link>
					}
				</Field>
				{
					!!order.details.plumbingPriceBucketCode &&
					<Field label={'Plumbing Schedule'}>
						<Link to={`/cfi/payment-schedule/details?priceBucketID=${order.details.plumbingPriceBucketID}&date=${formatDate(order.details.roDate, 'yyyy-MM-dd')}`}
							target="_blank">
							{order.details.plumbingPriceBucketCode}
						</Link>
					</Field>
				}
			</Card>
		</>
	);
}
